const removeDuplicateEANProducts = (productos) => {
  const removeDuplicateEan = productos.reduce((list, product, index) => {
    product.index = index;
    list[product.ean] = product;
    return list;
  }, {});

  return Object.values(removeDuplicateEan);
};

const removeDuplicateITFProducts = (productos) => {

  const removeDuplicateItf = productos.reduce((list, product, index) => {
    product.index = index;
    list[product.itf] = product;
    return list;
  }, {});

  return Object.values(removeDuplicateItf);
};

const filterAllProductsByEAN = (productos, id, catalogoId) => {

  if(catalogoId) {
    return productos.filter((element) => element.ean === id && element.catalogo === catalogoId);

  } else {
    return productos.filter((element) => element.ean === id);

  }
};

const filterAllProductsByITF = (productos, id) => {
  return productos.filter((element) => element.itf === id);
};



const generatePopUpsDataByCatalog = (groupPopups, catalogoId) => {

  const findPopupByCatalog = groupPopups.byCatalog[catalogoId];

  if(findPopupByCatalog) {

  const newPopups =  Object.keys(findPopupByCatalog).reduce((list, key) => {

      if(list[key] && list[key].length > 0) {
        list[key] = findPopupByCatalog[key]

      } else {
        list[key] = [];
        list[key].push(findPopupByCatalog[key][0])
      }

      return list;

    }, groupPopups.byClave)

    return newPopups;

  } else {

    return groupPopups.byClave;
  }

}

export {
  removeDuplicateEANProducts,
  removeDuplicateITFProducts,
  filterAllProductsByEAN,
  filterAllProductsByITF,
  generatePopUpsDataByCatalog,
};
